export const DashboardEventOptions = {
  namespace: 'Dashboard',
  source: 'middleware',
} as const;
